import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component, Children } from 'react';
import CookieBanner from 'client/components/banner/CookieBanner';
import NpnFooter from 'client/components/npnFooter';
import 'client/styles/common.scss';
import 'client/styles/account.scss';

class App extends Component {
  static propTypes = {
    location: PropTypes.shape({
      query: PropTypes.object,
    }).isRequired,
    children: PropTypes.element.isRequired,
  };

  constructor(props) {
    super(props);
    const { location } = this.props;
    // keeping this somewhat vague so users are less likely
    // to mess with it if they see it in the url
    this.showPhone = !_.get(location, 'query.np');
  }

  render() {
    return (
      <div>
        {Children.only(this.props.children)}
        <CookieBanner />
        <NpnFooter showPhone={this.showPhone} />
      </div>
    );
  }
}

export default App;
